import { safeWindow } from 'frontend/utils/window';

// TODO: search for "process.env.VUE_ENV" in frontend/ and import this flag there instead
export const isServerEnv = () => process.env.VUE_ENV === 'server';

const QA_SERVER_PATTERN = /^(qa-.*\.)?brilliant\.org$/;
const BLOB_ZONE_PATTERN = /^(.*\.)?blob.zone$/;

export interface SentryEnvironment {
  environment: string;
  serverName: string;
}

export const getEnvironmentForErrorReporting: () => SentryEnvironment | null = () => {
  const safeWin = safeWindow();
  const hostname = safeWin?.location?.hostname;

  if (hostname == null || hostname === 'localhost.blob.zone') {
    return null;
  }

  if (hostname === 'brilliant.org') {
    return {
      environment: 'production',
      serverName: 'production',
    };
  }

  const matches = hostname.match(QA_SERVER_PATTERN) || hostname.match(BLOB_ZONE_PATTERN);
  if (matches) {
    const subdomain = matches[1];
    if (subdomain) {
      return {
        environment: 'qa',
        serverName: subdomain.substring(0, subdomain.length - 1),
      };
    }
  }

  return null;
};

export function getGraphQLEndpoint() {
  const env = getEnvironmentForErrorReporting();

  if (env?.environment === 'production') {
    return 'https://brilliant.org/graphql';
  }

  if (env?.environment === 'qa') {
    return 'https://api.blob.zone/graphql';
  }

  return 'http://localhost.blob.zone:8000/graphql';
}
